import Axios from 'axios'
import {callToActionUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_call_to_actions (context) {
    Axios.get(callToActionUrls.getAllCallToActions).then(function (response) {
      context.commit('GET_ALL_CALL_TO_ACTIONS', response.data)
    })
  },
  get_call_to_actions (context, publicId) {
    Axios.get(callToActionUrls.getCallToActions + publicId).then(function (response) {
      context.commit('GET_CALL_TO_ACTIONS', response.data)
    })
  },
  get_deleted_call_to_actions (context) {
    Axios.get(callToActionUrls.getDeletedCallToAction).then(function (response) {
      context.commit('GET_DELETED_CALL_TO_ACTIONS', response.data)
    })
  },
  get_call_to_action (context, publicId) {
    Axios.get(callToActionUrls.getCallToAction + publicId).then(function (response) {
      context.commit('GET_CALL_TO_ACTION', response.data)
    })
  },
  post_call_to_action (context, data) {
    Axios.post(callToActionUrls.postCallToAction, data).then(function () {
      context.dispatch('get_all_call_to_actions')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  update_call_to_action (context, data) {
    Axios.post(callToActionUrls.editCallToAction, data).then(function () {
      context.dispatch('get_all_call_to_actions')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  delete_call_to_action (context, publicId) {
    var postData = {
      deleted_by: localStorage.getItem('lkjhgfdsa')
    }
    Axios.post(callToActionUrls.deleteCallToAction + publicId, postData).then(function (response) {
      context.dispatch('get_all_call_to_actions')
    })
  },
  restoreCallToAction (context, publicId) {
    Axios.get(callToActionUrls.restoreCallToAction + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_CALL_TO_ACTIONS', response.data)
      router.push({
        name: 'Module.CallToActions'
      })
    })
  }
}
